import styled from 'styled-components';

export const DocumentContainer = styled.div`
  & > div:first-child {
    margin-bottom: 4px;
  }
  margin-bottom: 20px;
`;

export const FileWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  width: 288px;
  :hover {
    background-color: ${({ theme }) => theme.colors.tone.lightBlue};
  }
  border-radius: 4px;
  cursor: pointer;
  padding: 0 4px;
  & > div:first-child {
    display: flex;
  }
`;

export const Layout = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
`;
